import { cn } from "@app/lib/utils";
import { Project } from "@modules/home/data/mockData";
import { trans } from "@mongez/localization";
import { useState } from "react";

interface ProjectCardProps {
  project: Project;
}

export function ProjectCard({ project }: ProjectCardProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative flex h-[358px] w-full overflow-hidden rounded-3xl px-5 py-10 sm:h-[450px] sm:px-8 sm:py-16 lg:h-[28rem] lg:px-10 lg:py-10"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={project.image.url}
        alt={trans(project.title)}
        className={cn(
          "absolute inset-0 z-10 h-full w-full object-cover transition-all duration-500",
          isHovered ? "scale-150 grayscale-0" : "grayscale",
        )}
      />
      <div
        className={cn(
          "absolute inset-x-0 bottom-0 z-20 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-70 transition-all duration-300",
          isHovered ? "h-full" : "h-3/4",
        )}
      />

      <div className="z-30 mt-auto flex flex-col gap-2 text-white lg:gap-1">
        <h4 className="text-lg font-medium uppercase sm:text-xl lg:text-2xl">
          {trans(project.title)}
        </h4>
        <p className="text-sm sm:text-base lg:text-lg">{trans(project.city)}</p>
      </div>
    </div>
  );
}
